import { render, staticRenderFns } from "./RsaGestionePazientiAdiListPage.vue?vue&type=template&id=339c3de0"
import script from "./RsaGestionePazientiAdiListPage.vue?vue&type=script&lang=js"
export * from "./RsaGestionePazientiAdiListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports